module.exports = __WEBPACK_EXTERNAL_MODULE_react_router_dom__;